import React from 'react';
import {
    CollapsibleOuterDiv,
    CollapsibleInnerDiv,
    CollapsibleInnerHeader,
    CollapsibleOuterUnderlineGray,
    ArrowUp,
    ArrowDown,
    CustomLink
} from '../ServicePageContainer';
import { MenuSubItemComponent } from './MenuSubItemComponent';

export class MenuItemComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
        this.togglePanel = this.togglePanel.bind(this);
    }

    togglePanel(e) {
        this.setState({ open: !this.state.open });
    }

    render() {
        const { menuItem, url } = this.props;
        var lengthSubMenuList = menuItem.childNavigationLinks.length;

        var index = 0;
        return (
            <>
                <CollapsibleOuterDiv onClick={e => this.togglePanel(e)}>
                    <CollapsibleInnerDiv>
                        <CollapsibleInnerHeader> <CustomLink nounderline to={url[0]}>
                            {menuItem.name}
                        </CustomLink></CollapsibleInnerHeader>
                        {menuItem.childNavigationLinks.length > 0 ?
                            this.state.open ? <ArrowUp /> : <ArrowDown /> : ""}
                    </CollapsibleInnerDiv>
                </CollapsibleOuterDiv>
                <CollapsibleOuterUnderlineGray />
                {menuItem.childNavigationLinks.length > 0 && this.state.open === true ?
                    menuItem.childNavigationLinks.map((menuSubItem) => {
                        //not great but map index didnt work since list is any
                        index++;
                        return (
                            <MenuSubItemComponent menuSubItem={menuSubItem} url={menuSubItem.url} lengthSubMenuList={lengthSubMenuList} index={index} />
                        );
                    }
                    ) : ""}
                {this.state.open && menuItem.childNavigationLinks.length > 0 &&
                    <CollapsibleOuterUnderlineGray />}

            </>
        );
    }
}
;
